import * as React from "react";
import { 
    List, 
    Create, 
    Edit, 
    Show, 
    SimpleShowLayout, 
    SimpleForm, 
    TextInput, 
    Datagrid, 
    TextField,
    //DateField, 
    EditButton,
    ShowButton, 
    DeleteButton,
    //TabbedShowLayout,
    //Tab,
    //ReferenceManyField,
    //ReferenceField,
    //NumberField,
    BooleanField,
    BooleanInput,
    //ShowContextProvider,
    //useShowController,
    //ShowView,
    useRecordContext,
    EmailField,
    PasswordInput,
    required,

} from 'react-admin';

const UserTitle = () => {
    const record = useRecordContext();
    return <span>Пользователь: {record ? `${record.firstname}` : ''}</span>;
};
// const UserTitle = () => {
//     const record = useRecordContext();
//     return <span>Post {record ? `"${record.title}"` : ''}</span>;
//     };

export const UserList = (props) => {
    return (
        <List title="Пользователи" {...props}>
            <Datagrid rowClick="show">
                <TextField label="ID" source="id" />
                <TextField label="Имя пользователя" source="login" />
                <TextField label="Дата создания" source="created_at" />
                <EditButton />
                <ShowButton />
                <DeleteButton />
            </Datagrid>
        </List>
    )
}

export const UserShow = (props) => {
    return (
        <Show title={<UserTitle />} {...props}>
            <SimpleShowLayout>
                <TextField label="ID" source="id" />
                <TextField label="Дата создания" source="created_at" />
                <TextField label="Имя пользователя" source="login" />
                <TextField label="Имя" source="firstname" />
                <TextField label="Фамилия" source="lastname" />
                <EmailField label="Email" source="email" />
                <BooleanField label="Администратор" source="admin" />
            </SimpleShowLayout>
            <EditButton />
        </Show>
    )
}

export const UserEdit = props => (
    <Edit title={<UserTitle />} {...props}>
        <SimpleForm>
                <TextInput label="ID" disabled source="id" />
                <TextInput label="Дата создания" disabled source="created_at" />
                <TextInput label="Имя пользователя" source="login" validate={[required()]}/>
                <PasswordInput label="Пароль" source="password" validate={[required()]}/>
                <TextInput label="Имя" source="firstname" />
                <TextInput label="Фамилия" source="lastname" />
                <TextInput label="Email" source="email" validate={[required()]}/>
                <BooleanInput label="Администратор" source="admin" />
        </SimpleForm>
        {/* <DeleteButton /> */}
    </Edit>
);

export const UserCreate = props => (
    <Create title="Создание нового пользователя" {...props}>
        <SimpleForm>
            <TextInput label="Имя пользователя" source="login" validate={[required()]}/>
            <PasswordInput source="password" validate={[required()]}/>
            <TextInput label="Имя" source="firstname" />
            <TextInput label="Фамилия" source="lastname" />
            <TextInput label="Email" source="email" />
            <BooleanInput label="Администратор" source="admin" />
        </SimpleForm>
    </Create>
);

// export const UserDelete = props => (
//     <Delete {...props}>
